import { RosterRequestQuery, RosterRequestType } from 'generated/graphql';
import { useClientRequiredFieldsAndPod } from 'hooks/useClientRequiredFieldsAndPod';

type DetailsProps = {
  request: RosterRequestQuery['rosterRequest'];
};

const Details = ({ request }: DetailsProps) => {
  const { clientRequiredFields } = useClientRequiredFieldsAndPod();

  // Get required fields based on request type
  const requiredFields = (() => {
    if (!request.requestData) return null;

    if (
      request.requestType === RosterRequestType.NewReservation &&
      request.requestData.__typename === 'RosterRequestDataNewReservation'
    ) {
      return request.requestData.requiredFields;
    }

    if (
      request.requestType === RosterRequestType.NewGroupReservation &&
      request.requestData.__typename === 'RosterRequestDataNewGroupReservation'
    ) {
      return request.requestData.requiredFields;
    }

    return null;
  })();

  return (
    <>
      <h2 className="mb-5 text-lg text-primaryGray">Details</h2>
      <p className="mb-4">{request.details ?? 'No details provided'}</p>

      {/* Display Required Fields if present */}
      {requiredFields && requiredFields.length > 0 && (
        <div className="mt-4">
          <div>
            {requiredFields.map((field) => {
              // Find the label from client configuration
              const fieldConfig = clientRequiredFields?.find(
                (f) => f.value === field.name,
              );
              const label =
                fieldConfig?.label ||
                field.name
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (l) => l.toUpperCase());

              return (
                <div key={field.name} className="mb-2">
                  <span className="text-primaryGray">{label}: </span>
                  <span>{field.value || '-'}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default Details;
